import type { LeagueGameData, LeagueGames } from '@library/types/games';
import { DateTime } from 'luxon';

const sortGames = (a: LeagueGameData, b: LeagueGameData) => {
  const dateA = DateTime.fromISO(a.date_time).toMillis();
  const dateB = DateTime.fromISO(b.date_time).toMillis();

  return dateA - dateB;
};

export const orderGames = (games: LeagueGames): LeagueGames => {
  /*
    Games is now readonly, so we need to make a copy of it.
    In a recent js update, toSorted was introduced, but it's
    messing with the tsc so doing this for now. Should change later.
  */

  return [...games].sort(sortGames) as LeagueGames;
};
